<h1 mat-dialog-title>
    {{title}}
  </h1>
  
  <div mat-dialog-content>
    <p>{{message}}</p>
  </div>
  
  <div mat-dialog-actions>
    <button class="btn1" mat-mini-fab (click)="onDismiss()">No</button>
    <button class="btn" mat-mini-fab color="accent" (click)="onConfirm()">Yes</button>
  </div>
